// const cleanFeesGlobal = async () => {
//     console.log("Global: 🧹 Checking for duplicate fees (Aggressive Mode)...");
//     try {
//         const res = await fetch('/cart.js');
//         const cart = await res.json();
//         const FEE_VARIANT_ID = "52540555592047";

//         // Find ALL fee-like items
//         const feeItems = cart.items.filter(item => 
//            String(item.variant_id) === FEE_VARIANT_ID || 
//            item.product_title.toLowerCase().includes('tariff') ||
//            item.title.toLowerCase().includes('tariff') ||
//            item.title.toLowerCase().includes('fee')
//         );

//         if (feeItems.length <= 1) return;

//         console.log(`Global: ⚠️ Found ${feeItems.length} fee items. removing duplicates...`);

//         const updates = {};
//         let keptOne = false;
        
//         for (let i = feeItems.length - 1; i >= 0; i--) {
//            const item = feeItems[i];
//            const isOurFee = String(item.variant_id) === FEE_VARIANT_ID;
//            const isClean = !item.properties || Object.keys(item.properties).length === 0;

//            if (!keptOne && isOurFee && isClean) {
//               keptOne = true;
//            } 
//            else if (!keptOne && isOurFee) {
//                keptOne = true;
//            }
//            else {
//               updates[item.key] = 0;
//            }
//         }
        
//         if (!keptOne && feeItems.length > 0) {
//             const last = feeItems[feeItems.length-1];
//             if (updates[last.key] === 0) delete updates[last.key];
//         }

//         if (Object.keys(updates).length > 0) {
//            await fetch('/cart/update.js', {
//               method: 'POST',
//               headers: { 'Content-Type': 'application/json' },
//               body: JSON.stringify({ updates })
//            }).then(() => {
//                console.log("Global: ✨ Duplicates removed. Reloading...");
//                window.location.reload(); 
//            });
//         }
//     } catch (e) {
//         console.error("Global fee cleanup error:", e);
//     }
// };


const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.matches('dialog.ma-fees__dialog--confirmation')) {
            setTimeout(() => {
              // Check if we are on the cart page and if a discount is present OR global override is set
              // Use window.forceFeeDecline OR pathname check
              const isCart = window.location.pathname === '/cart' || window.location.pathname.includes('/cart');
              const hasDiscount = document.querySelector('.discounts__discount') !== null;
              
              if (window.forceFeeDecline || (isCart && hasDiscount)) {
                 console.log("Global: Discount detected (or forced by flag). Hiding popup.");
                 // Ghost Mode: Hide and Ignore
                 node.style.display = 'none';
                 node.style.visibility = 'hidden';
                 node.style.pointerEvents = 'none';
                 
                 // Trigger Cleanup immediately because Popup appearance implies potential duplicate fee added by App
                 cleanFeesGlobal();
                 
                 return;
              } else {
                 console.log("Global: No discount detected (or not cart). ACCEPTING fee.");
                 const acceptButton = node.querySelector('.ma-fees__buttons [data-action="accept"]');
                 if (acceptButton) acceptButton.click();
              }
            }, 50); // small delay to make sure content is fully loaded
          }
        }
      });
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
// tarik cleanup
// (function() {
//   function deleteCookie(name, domain) {
//     document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=' + domain;
//   }

//   function getCookieValue(name) {
//     var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
//     return match ? match[1] : null;
//   }

//   if (getCookieValue('_muse_store') === 'sandbox') {
//     deleteCookie('_muse_store', 'choosemuse.com');
//     deleteCookie('_muse_store', '.choosemuse.com');
//     deleteCookie('_muse_store', 'sandbox.choosemuse.com');
//     document.cookie = '_muse_store=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

//     if (getCookieValue('_muse_store') !== 'sandbox') {
//       window.location.reload();
//     } else {
//       console.warn('Could not delete _muse_store cookie');
//     }
//   }
// })();
document.addEventListener("DOMContentLoaded", function () {

    function _getCookie(t) {
        let e = document.cookie.match(new RegExp("(?:^|; )" + t.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
        return e ? e[1] : false
    }

    const euCountries = ["UK", "FR", "ES", "DE"],
        intlCountries = ["AU", "TH", "AR", "CL", "IL", "AE", "JP", "SG", "NZ", "IN"];

    function checkCountry() {
        console.info(`checkCountry`);

        let subdomain = location.hostname.split('.').shift();
        if (subdomain === 'choosemuse') subdomain = 'us';

        localStorage.setItem('subdomainCountryCode', subdomain);

        const userCountry = localStorage.getItem('ip_country');
        const museLocation = localStorage.getItem('muse_location');
        const storeCountry = _getCookie("_muse_store");

        console.log('subdomainCountry', subdomain, "ipCountry", userCountry, "cookie", storeCountry, "museLocation", museLocation);

        if (userCountry && (userCountry.toLocaleLowerCase() === storeCountry || museLocation === storeCountry)) {
            console.info(`checkCountry > User is in ${userCountry} and in ${storeCountry.toUpperCase()} Store`);
            return;
        }

        const apiUrl = `http://api.ipstack.com/check?access_key=f3287ae9e3cbb4c36c2cfff6b8b9fe28`;
        fetch(apiUrl, {
            method: "POST",
            headers: {}
        }).then(res => res.json()).then(res => {
            const countryCode = res.country_code;

            if (!countryCode) {
                console.warn("checkCountry > No country code returned from API");
                return;
            }

            localStorage.setItem('ipCountryCode', countryCode);
            localStorage.setItem('ip_country', countryCode);

            const existingMuseLocation = localStorage.getItem('muse_location');
            if (!existingMuseLocation) {
                const currentStore = _getCookie("_muse_store");
                if (currentStore) localStorage.setItem('muse_location', currentStore);
            }

            const isEuCountry = euCountries.find(country => country === countryCode);
            const isIntlCountry = intlCountries.find(country => country === countryCode);

            if (countryCode.toLowerCase() !== storeCountry ||
                (isEuCountry && storeCountry !== "eu") ||
                (isIntlCountry && storeCountry !== "intl")) {
                console.info(`checkCountry > User is in ${countryCode}`);
            }

            console.log("Check Country Finished");
        });
    }

    checkCountry();

    const setRegion = () => {
        const redirectPages = ["/cart", "/checkout", "/products", "/pages/premium-subscription", "/pages/muse-connect", "/pages/compare", "/pages/shop", "/pages/shop-in-bulk", "/pages/shop-accessories"];
        let _countryCode = _getCookie("_muse_store");
        const storeTexts = document.querySelectorAll("span.header__store-content");
        const storeFlags = document.querySelectorAll("img.header__store-flag");
        console.log("countryCode", _countryCode);
        if (!_countryCode) _countryCode = localStorage.getItem('subdomainCountryCode');
        if (!_countryCode) _countryCode = 'us';
        storeFlags.forEach(S => {
            const newSrcWords = S.src.split('/');
            const flagWords = newSrcWords[8].split('-');
            flagWords[0] = _countryCode;
            newSrcWords[8] = flagWords.join('-');
            const newSrc = newSrcWords.join('/');
            S.src = newSrc;
            S.style.display = 'block';
        });
        storeTexts.forEach(S => {
            S.textContent = _countryCode === "eu" ? "EU / UK Store" : `${_countryCode.toUpperCase()} Store`;
            S.style.display = 'block';
        });
        if (_countryCode.toUpperCase() == 'US') _countryCode = ''
        else _countryCode = `${_countryCode}.`
        // redirectPages.forEach(link => {
        //     document.querySelectorAll('a[href]').forEach(elem => {
        //         if (elem.href.includes(link)) {
        //             elem.href = `https://${_countryCode}choosemuse.com${link}`;
        //         }
        //     })
        // })
    }

    window.onload = setRegion;
});

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
}

function clearChooseMuseStorage() {
    try {
        const isFirstLoad = localStorage.getItem('initialized');

        if (!isFirstLoad) {
            const klipSession = getCookie('klip-session_uid');

            if (klipSession) {
                console.log('Clearing choosemuse storage...');

                const preservedKeys = ['ip_country', 'ipCountryCode', 'subdomainCountryCode', 'muse_location', 'initialized'];

                const keysToRemove = [];
                for (let i = 0; i < localStorage.length; i++) {
                    const key = localStorage.key(i);

                    
                    if (preservedKeys.includes(key)) continue;

                    if (key.includes('choosemuse') ||
                        key.includes('muse') ||
                        key.includes('klip')
                    ) {
                        keysToRemove.push(key);
                    }
                }

                keysToRemove.forEach(key => {
                    console.log('Removing:', key);
                    localStorage.removeItem(key);
                });

                sessionStorage.clear();
                console.log(`Cleared ${keysToRemove.length} choosemuse items`);
            }

            localStorage.setItem('initialized', 'true');
        }
    } catch (error) {
        console.error('Error during storage clear:', error);
    }
}


clearChooseMuseStorage();

// Advanced sticky navbar with coordinate tracking
(function () {
    const navbar = document.querySelector('.v2-floating-header__navbar');
    const container = document.querySelector('.v2-floating-header__container');

    if (!navbar || !container) return;

    // Fixed sticky threshold
    const STICKY_THRESHOLD = 494;

    let navbarData = {
        height: 0,
        isSticky: false
    };

    function init() {
        const navbarRect = navbar.getBoundingClientRect();
        navbarData.height = navbarRect.height;
        navbarData.isSticky = navbar.classList.contains('is-sticky');
        checkScroll();
    }

    function checkScroll() {
        const currentScroll = window.scrollY;

        if (currentScroll >= STICKY_THRESHOLD) {
            if (!navbarData.isSticky) {
                navbar.classList.add('is-sticky');
                navbarData.isSticky = true;
            }
        } else {
            if (navbarData.isSticky) {
                navbar.classList.remove('is-sticky');
                navbarData.isSticky = false;
            }
        }
    }

    // Throttle scroll events
    let ticking = false;
    function onScroll() {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                checkScroll();
                ticking = false;
            });
            ticking = true;
        }
    }

    init();

    window.addEventListener('scroll', onScroll, { passive: true });

    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(init, 250);
    });

    window.navbarDebug = navbarData;
})();

// Global table class in article
document.querySelectorAll('.site-post-container-content table').forEach(table => {
    table.parentElement.classList.add('table-responsive-wrapper');
});


  
     
